module.exports = __webpack_public_path__ + "img/unforeseen-corners.bbc59d93.jpg";